import { TimeOffType } from '@sdk/timeOffs/types/TimeOffType';

import getPaidTimeOffTypes from './getTimeOffTypes';
import getUnpaidTimeOffTypes from './getUnpaidTimeOffTypes';

const sortTimeOfTypes = (timeOffTypes: TimeOffType[]): TimeOffType[] => {
  return [...getPaidTimeOffTypes(timeOffTypes), ...getUnpaidTimeOffTypes(timeOffTypes)];
};

export default sortTimeOfTypes;
